import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "@common/api/apiShared";
import { Result } from "@common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { IDeleteScenarioDialog } from "./DeleteScenarioDialog";

export function useDeleteScenarioDialog(props: IDeleteScenarioDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeScenario = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<string>) => {
                props.onClose();

                if (response.success()) {
                    props.onDeleted();
                    snackbar.show(createElement(Trans, { i18nKey: "dataDeleted", values: { name: props.scenario.name } }));
                }
            },
        });
    };

    async function remove() {
        return await deleteHttp<string>(`/risk-assessments/${props.scenario.id}`);
    }

    return {
        removeScenario,
        inProgress: removeMutation.isLoading,
    };
}
